const RatingOptions = [
  {
    description: t('grades.ratings.unsatisfactory'),
    score: 1,
  },
  {
    description: t('grades.ratings.needs_improvement'),
    score: 2,
  },
  {
    description: t('grades.ratings.meets_expectations'),
    score: 3,
  },
  {
    description: t('grades.ratings.exceeds_expectations'),
    score: 5,
  },
  {
    description: t('grades.ratings.exceptional'),
    score: 4,
  },
];

export default RatingOptions;
